/* eslint-disable no-redeclare, no-inner-declarations */
// tslint:disable: ban-types
import Vue from 'vue'

/**
 * 捕捉目标方法的异常(同步或异步)并用`Notify`方式显示
 */
function Catch(
  target: Object,
  propertyKey: string | symbol,
  descriptor: PropertyDescriptor
): PropertyDescriptor | void {
  descriptor.value = Catch.wrap(descriptor.value)
}

namespace Catch {
  /**
   * 捕捉目标方法的异常(同步或异步)并用`Notify`方式显示
   *
   * @param func 要进行封装的方法
   */
  export function wrap<T extends Function>(func: T): T {
    return async function(this: Vue, ...args: any[]) {
      try {
        return await func.apply(this, args)
      } catch (e) {
        this.$notify({ type: 'danger', message: e.message })
      }
    } as any
  }
}

export default Catch
